import { globalInvoiceTypes } from "redux/reducers/globalInvoices/types";
import {
  setSnackbar,
  startRequestComp,
  stopRequestComp,
} from "../search/searchActions";
import { api_get, api_post, PROYECT } from "services/api";

const {
  GET_GLOBAL_INVOICE_PAYMENTS_TYPES,
  GET_GLOBAL_INVOICE_LICENSES,
  CREATE_GLOBAL_INVOICE_BREAKDOWN,
  GET_GLOBAL_INVOICE,
  SET_GLOBAL_INVOICE_FILTERS,
  SET_GLOBAL_INVOICE_UNIT_PRICES,
  SET_GLOBAL_INVOICE_QUANTITY,
} = globalInvoiceTypes;

export const getGlobalInvoicesPaymentTypes = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/payments`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingGlobalInvoices"));
    await api_get(url)
      .then((resp) => {
        if (resp.length === 0)
          dispatch(setSnackbar("No se encontraron tipos de pago"));
        dispatch({
          type: GET_GLOBAL_INVOICE_PAYMENTS_TYPES,
          payload: resp,
        });
      })
      .catch((error) => dispatch(setSnackbar(error)));
    dispatch(stopRequestComp("loadingGlobalInvoices"));
  };
};

export const getGlobalInvoicesCRELicenses = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/stations/cre_licenses`;
  let payload = {};
  return async (dispatch) => {
    dispatch(startRequestComp("loadingGlobalInvoices"));
    await api_get(url)
      .then((resp) => {
        payload = {
          type: GET_GLOBAL_INVOICE_LICENSES,
          payload: resp.map((license) => ({
            ...license,
            label: license?.creLicense,
          })),
        };
        dispatch(payload);
      })
      .catch((error) =>
        dispatch(
          setSnackbar(error ? error : "Error contacte al administrador"),
        ),
      );
    dispatch(stopRequestComp("loadingGlobalInvoices"));
  };
};

export const getGlobalInvoice = (station = {}, start, end) => {
  const params = `?station=${station?.id}&start=${start}&end=${end}`;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/global-stamp${params}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingGlobalInvoices"));
    await api_get(url)
      .then((resp) => {
        dispatch({
          type: GET_GLOBAL_INVOICE,
          payload: resp,
        });
      })
      .catch((error) => {
        dispatch(setSnackbar(error));
        dispatch({
          type: GET_GLOBAL_INVOICE,
          payload: false,
        });
      })
      .finally(() => dispatch(stopRequestComp("loadingGlobalInvoices")));
  };
};

// El POST reemplaza a los dos anteriores (global-stamp y
// global-stamp/payment-breakdown), eliminados en CRM-3109. Desde CRM-3109 es
// asincrono: solo encola las facturas (quedan en PENDIENTE) y responde de
// inmediato con {message}, sin el resultado por permiso/pago. El avance real
// se consulta aparte en la vista "Estatus Facturacion Global"
// (GET /invoices/global-invoice-details).
export const createGlobalInvoicePaymentBreakdown = (
  form,
  action = () => ({}),
) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/global-stamp/v4`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingGlobalInvoices"));
    try {
      const resp = await api_post(url, form);
      dispatch({ type: CREATE_GLOBAL_INVOICE_BREAKDOWN });
      dispatch(setSnackbar(resp?.message, "success"));
      // La peticion salio bien: se cierra el modal de fecha de emision.
      action();
      return resp;
    } catch (error) {
      // Peticion fallida (red, validacion): el modal se queda abierto para
      // que el usuario corrija y reintente.
      dispatch(setSnackbar(error));
      return null;
    } finally {
      dispatch(stopRequestComp("loadingGlobalInvoices"));
    }
  };
};

export const setGlobalInvoicesFilters = (key = "", data) => ({
  type: SET_GLOBAL_INVOICE_FILTERS,
  payload: { data, key },
});

// La terna permiso + tasa + metodo de pago es lo que identifica un renglon
// ahora que la vista muestra varios permisos a la vez.
export const setGlobalInvoicesUnitPrices = (
  creLicense,
  taxRate,
  paymentKey,
  unitPrice,
) => ({
  type: SET_GLOBAL_INVOICE_UNIT_PRICES,
  payload: { creLicense, taxRate, paymentKey, unitPrice },
});

export const setGlobalInvoicesQuantity = (
  creLicense,
  taxRate,
  paymentKey,
  quantity,
) => ({
  type: SET_GLOBAL_INVOICE_QUANTITY,
  payload: { creLicense, taxRate, paymentKey, quantity },
});
